import { render, staticRenderFns } from "./Modalform.vue?vue&type=template&id=21e42aa4&"
import script from "./Modalform.vue?vue&type=script&lang=js&"
export * from "./Modalform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports